"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationClient = void 0;
var BaseUrl_1 = require("../BaseUrl");
var __1 = require("..");
var Menu_1 = require("../models/Menu");
var Product_1 = require("../models/Product");
var baseUrl = new BaseUrl_1.BaseUrl({ url: "" });
var setBaseUrl = function (url) {
    baseUrl.url = url;
};
var getLocations = function () {
    return fetch(baseUrl.url + "/locations")
        .then(function (response) { return response.json()
        .then(function (data) { return data.map(function (location) { return new __1.Location(location); }); }); });
};
var getLocation = function (locationID) {
    return fetch(baseUrl.url + "/locations/" + locationID)
        .then(function (response) { return response.json()
        .then(function (data) { return new __1.Location(data); }); });
};
var getMenuItem = function (locationId, menuId, itemId) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu/" + menuId + "/items/" + itemId)
        .then(function (response) { return response.json()
        .then(function (data) { return new Menu_1.MenuItem(data); }); });
};
var createMenuItem = function (locationId, menuId, item, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu/" + menuId + "/items", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(item),
    }).then(function (response) { return response.json()
        .then(function (data) { return new Menu_1.MenuItem(data); }); });
};
var updateMenuItem = function (locationId, menuId, itemId, item, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu/" + menuId + "/items/" + itemId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(item),
    }).then(function (response) { return response.json()
        .then(function (data) { return new Menu_1.MenuItem(data); }); });
};
var deleteMenuItem = function (locationId, menuId, itemId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu/" + menuId + "/items/" + itemId, {
        method: "DELETE",
        headers: { "Authorization": authToken }
    }).then(function (response) { return console.log(response); });
};
var getMenu = function (locationId, menuId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu/" + menuId, {
        headers: { "Authorization": authToken }
    }).then(function (response) { return response.json()
        .then(function (data) { return new Menu_1.Menu(data); }); });
};
var getMenus = function (locationId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu", {
        headers: { "Authorization": authToken }
    }).then(function (response) { return response.json()
        .then(function (data) {
        var menus = data;
        return menus;
    }); });
};
var getLiveAndActiveMenus = function (locationId) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu/live")
        .then(function (response) { return response.json()
        .then(function (data) {
        var menus = data;
        return menus;
    }); });
};
var createMenu = function (locationId, menu, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(menu),
    }).then(function (response) { return response.json()
        .then(function (data) { return new Menu_1.Menu(data); }); });
};
var updateMenu = function (locationId, menuId, menu, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu/" + menuId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(menu),
    }).then(function (response) { return response.json()
        .then(function (data) { return new Menu_1.Menu(data); }); });
};
var deleteMenu = function (locationId, menuId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/menu/" + menuId, {
        method: "DELETE",
        headers: { "Authorization": authToken, }
    }).then(function (response) { return console.log(response); });
};
var getProduct = function (locationId, productId) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/products/" + productId)
        .then(function (response) { return response.json()
        .then(function (data) { return new Product_1.Product(data); }); });
};
var getProducts = function (locationId) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/products")
        .then(function (response) { return response.json()
        .then(function (data) {
        var products = data;
        return products;
    }); });
};
var createProduct = function (locationId, product, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/products", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(product),
    }).then(function (response) { return response.json()
        .then(function (data) { return new Product_1.Product(data); }); });
};
var updateProduct = function (locationId, productId, product, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/products/" + productId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(product),
    }).then(function (response) { return response.json()
        .then(function (data) { return new Product_1.Product(data); }); });
};
var deleteProduct = function (locationId, productId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/products/" + productId, {
        method: "DELETE",
        headers: { "Authorization": authToken, }
    }).then(function (response) {
        if (response.status === 200) {
            return { success: true };
        }
        if (response.status === 422) {
            return response.json().then(function (data) { return data; });
        }
    });
};
var getArea = function (locationId, areaId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/areas/" + areaId, { headers: { "Authorization": authToken } })
        .then(function (response) { return response.json()
        .then(function (data) { return new __1.Area(data); }); });
};
var getAreas = function (locationId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/areas", { headers: { "Authorization": authToken } })
        .then(function (response) { return response.json()
        .then(function (data) {
        var areas = data;
        return areas;
    }); });
};
var createArea = function (locationId, area, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/areas", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(area),
    }).then(function (response) { return response.json()
        .then(function (data) { return new __1.Area(data); }); });
};
var deleteArea = function (locationId, areaId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/areas/" + areaId, {
        method: "DELETE",
        headers: { "Authorization": authToken, }
    }).then(function (response) { return console.log(response); });
};
var getInvoiceUrl = function (locationId, invoiceId, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/invoice/" + invoiceId, {
        headers: { "Authorization": authToken },
    })
        .then(function (resp) { return resp.json(); })
        .then(function (json) { return json.invoiceUrl; });
};
var createAssetUrl = function (locationId, asset, authToken) {
    return fetch(baseUrl.url + "/locations/" + locationId + "/asset", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": authToken,
        },
        body: JSON.stringify(asset),
    }).then(function (response) { return response.json()
        .then(function (data) { return data; }); });
};
exports.LocationClient = {
    setBaseUrl: setBaseUrl,
    getLocation: getLocation,
    getLocations: getLocations,
    getMenuItem: getMenuItem,
    createMenuItem: createMenuItem,
    updateMenuItem: updateMenuItem,
    deleteMenuItem: deleteMenuItem,
    getMenu: getMenu,
    getMenus: getMenus,
    getLiveAndActiveMenus: getLiveAndActiveMenus,
    createMenu: createMenu,
    updateMenu: updateMenu,
    deleteMenu: deleteMenu,
    getProduct: getProduct,
    getProducts: getProducts,
    createProduct: createProduct,
    updateProduct: updateProduct,
    deleteProduct: deleteProduct,
    getArea: getArea,
    getAreas: getAreas,
    createArea: createArea,
    deleteArea: deleteArea,
    getInvoiceUrl: getInvoiceUrl,
    createAssetUrl: createAssetUrl,
};
